// extracted by mini-css-extract-plugin
export default {"root":"WaveContainer-module__root","wave":"WaveContainer-module__wave","waveGrow":"WaveContainer-module__waveGrow"};